/* eslint-disable @typescript-eslint/no-use-before-define */

import { Benefits } from "../components/Benefits"
import { formatPrice } from "../components/formatPrice"
import { Logo } from "../components/Logo"
import { navigate } from "../hooks/navigation"
import { usePrices } from "../hooks/support"
import { t } from "../hooks/translations"
import { $user, useUser } from "../hooks/user"
import { Check } from "../icons/check"
import css from "../style.module.scss"

type OffersScreenProps = {
  onClick?: () => void
}

export const OffersScreen = function OffersScreen({ onClick }: OffersScreenProps) {
  return (
    <>
      <Logo style={{ marginBottom: 16 }} />
      <Benefits />
      <OffersSelector onClick={onClick} />
    </>
  )
}

type OffersSelectorProps = {
  onClick?: () => void
}

const OffersSelector = function OffersSelector({ onClick }: OffersSelectorProps) {
  const { offer, signedIn } = useUser()

  const { currency, annually, monthly } = usePrices()

  const savePercent = Math.round(
    ((monthly.unit_amount * 12 - annually.unit_amount) / (monthly.unit_amount * 12)) * 100,
  )

  return (
    <div className={css["offers-container"]}>
      {offer === "yearly" && (
        <span className={css["offers-badge"]}>{t("save_percent", { percent: savePercent })}</span>
      )}
      {offer === "monthly" && <span className={css["offers-badge"]}>{t("most_flexible")}</span>}
      <form
        method="post"
        className={css.offers}
        onSubmit={(event) => {
          event.preventDefault()

          navigate(signedIn ? "Payment" : "SignUp")

          onClick?.()
        }}
      >
        <fieldset className={css["offers-fieldset"]}>
          <label htmlFor="offer-yearly" className={css["offers-label"]}>
            <div className={css["offers-name"]}>{t("annual")}</div>
            <div className={css["offers-price"]}>
              {formatPrice({ prefix: currency.prefix, unitAmount: annually.unit_amount / 100 })}
            </div>
            <div className={css["offers-comment"]}>
              {t("sum_per_month", {
                sum: formatPrice({
                  prefix: currency.prefix,
                  unitAmount: annually.unit_amount / 100 / 12,
                }),
              })}
            </div>
            <span className={css["offers-icon"]}>
              <Check size={12} color="white" />
            </span>
            <input
              type="radio"
              name="offers"
              id="offer-yearly"
              className={css["offers-input"]}
              checked={offer === "yearly"}
              onChange={() => $user.setKey("offer", "yearly")}
            />
          </label>
          <label htmlFor="offer-monthly" className={css["offers-label"]}>
            <div className={css["offers-name"]}>{t("monthly")}</div>
            <div className={css["offers-price"]}>
              {formatPrice({ prefix: currency.prefix, unitAmount: monthly.unit_amount / 100 })}
            </div>
            <div className={css["offers-comment"]}>{t("billed_monthly")}</div>
            <span className={css["offers-icon"]}>
              <Check size={12} color="white" />
            </span>
            <input
              type="radio"
              name="offers"
              id="offer-monthly"
              className={css["offers-input"]}
              checked={offer === "monthly"}
              onChange={() => $user.setKey("offer", "monthly")}
            />
          </label>
        </fieldset>

        <button type="submit" className={css.button}>
          {t("continue")}
        </button>
      </form>
    </div>
  )
}
